import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'receipted', label: 'Receipted' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'employer_name', label: 'Employer' },
  { key: 'period_start', label: 'Period Start' },
  { key: 'period_end', label: 'Period End' },
  { key: 'due_date', label: 'Due Date' },
  { key: 'status', label: 'Status' },
  { key: 'total_due', label: 'Amount Due', align: 'right', type: 'money' },
  { key: 'paid_to_date', label: 'Paid to Date', align: 'right', type: 'money' },
  { key: 'outstanding', label: 'Outstanding', align: 'right', type: 'money' },
  { key: 'receipt_number', label: 'Receipt #' },
];

export function ContributionSchedulesReport() {
  return (
    <ReportView
      title="Contribution Schedules Register"
      description="Every contribution schedule submitted by employers, with amount due, paid and outstanding."
      endpoint="/reports/memberships/contribution-schedules"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      defaultSort="period_start"
    />
  );
}
